/**
 * Pull the human-readable message out of a failed API call.
 *
 * The axios wrapper rejects with the raw error, and this backend reports
 * failures as `{"error": "..."}` (with `{"detail": "..."}` from DRF's own
 * permission/auth layer, and `{"success": false, "message": "..."}` from
 * `api_response` and the validation handler). Several pages had each
 * re-derived this with an `as any` cast; this is the typed version.
 *
 * Always returns something printable — an error the admin cannot see is worse
 * than an ugly one, because the action silently appears to have worked.
 */
export function apiErrorMessage(error: unknown, fallback = "Something went wrong"): string {
  const response = (
    error as { response?: { data?: { error?: unknown; detail?: unknown; message?: unknown } } } | undefined
  )?.response;
  const data = response?.data;

  if (typeof data?.error === "string" && data.error.trim()) return data.error;
  if (typeof data?.detail === "string" && data.detail.trim()) return data.detail;
  if (typeof data?.message === "string" && data.message.trim()) return data.message;
  if (error instanceof Error && error.message) return error.message;
  return fallback;
}
